import React from 'react'
import Svg from './Svg'
export const SvgGrid = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 0h10.424v10.424H0zm13.402 0h10.423v10.424H13.402zM0 13.402h10.424v10.423H0zm13.402 0h10.423v10.423H13.402z" />
  </Svg>
))
SvgGrid.isIcon = true
export default SvgGrid
